import { ingredientSlice } from "./store/ingredient.slice";
import {
  ingredientApi,
  useGetIngredientsQuery,
  useCreateIngredientMutation,
  useUpdateIngredientMutation,
  useLazyGetIngredientByIdQuery,
  useLazyGetIngredientsQuery,
  useDeleteIngredientMutation
} from "./api/ingredient.api";

export const { setIngredients } = ingredientSlice.actions;

export {
  ingredientApi,
  ingredientSlice,
  useGetIngredientsQuery,
  useCreateIngredientMutation,
  useUpdateIngredientMutation,
  useLazyGetIngredientByIdQuery,
  useLazyGetIngredientsQuery,
  useDeleteIngredientMutation
};
